import { cn } from '@/utils'
import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { useMatch, useNavigate } from 'react-router-dom'

type Props = {
	onResize?: (height: number) => void
}

export const Navigator = ({ onResize }: Props) => {
	const home = useMatch('/app')
	const history = useMatch('/history/*')
	const profile = useMatch('/profile/*')
	const upload = useMatch('/link/submit/*')
	const reward = useMatch('/reward/*')

	const ref = useRef<HTMLDivElement>(null)

	const navigate = useNavigate()

	const container = document.getElementById('navigator')

	useEffect(() => {
		setTimeout(() => {
			if (ref.current) {
				onResize?.(ref.current.offsetHeight)
			}
		}, 1)

		const handleResize = () => {
			if (ref.current) {
				onResize?.(ref.current.offsetHeight)
			}
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	if (!container) return null

	return (
		<div className="md:hidden">
			{createPortal(
				<div className="fixed inset-x-0 bottom-0 z-40 flex justify-center pointer-events-none">
					<div className="w-full max-w-mobile p-5 pointer-events-auto">
						<div
							ref={ref}
							className="bg-white h-[67px] px-[20px] rounded-[24px] shadow-sm border border-gray-50 flex items-center"
						>
							<div className="flex w-full justify-around">
									<div
										className="flex flex-col items-center justify-center basis-1/5 gap-1"
										onClick={() => navigate('/app')}
									>
										<img
											className="h-[22px] w-[22px]"
											src={
												home
													? require('@/assets/icons/home-active.png')
													: require('@/assets/icons/home-inactive.png')
											}
											alt="Home"
										/>
										<div
											className={cn(
												'font-medium text-gray-500 text-[12px] leading-none',
												home && 'font-bold text-blue-600'
											)}
										>
											Home
										</div>
										<div className={cn('h-[3px] w-[5px] rounded-[100px] bg-[#3369B2]', !home && 'invisible')} />
									</div>
									<div
										className="flex flex-col items-center justify-center basis-1/5 gap-1"
										onClick={() => navigate('/link/submit')}
									>
										<img
											className="h-[22px] w-[22px]"
											src={
												upload
													? require('@/assets/icons/upload-active.png')
													: require('@/assets/icons/upload-inactive.png')
											}
											alt="Content"
										/>
										<div
											className={cn(
												'font-medium text-gray-500 text-[12px] leading-none',
												upload && 'font-bold text-blue-600'
											)}
										>
											Content
										</div>
										<div className={cn('h-[3px] w-[5px] rounded-[100px] bg-[#3369B2]', !upload && 'invisible')} />
									</div>
									<div
										className="flex flex-col items-center justify-center basis-1/5 gap-1"
										onClick={() => navigate('/reward')}
									>
										{reward ? (
											<span
												className="h-[22px] w-[22px]"
												style={{
													backgroundColor: '#0C4C90',
													maskImage: `url(${require('@/assets/icons/reward-active.png')})`,
													maskRepeat: 'no-repeat',
													maskPosition: 'center',
													maskSize: 'contain',
													WebkitMaskImage: `url(${require('@/assets/icons/reward-active.png')})`,
													WebkitMaskRepeat: 'no-repeat',
													WebkitMaskPosition: 'center',
													WebkitMaskSize: 'contain'
												}}
												aria-label="Reward"
											/>
										) : (
											<img
												className="h-[22px] w-[22px] grayscale opacity-70"
												src={require('@/assets/icons/reward-inactive.png')}
												alt="Reward"
											/>
										)}
										<div
											className={cn(
												'font-medium text-gray-500 text-[12px] leading-none',
												reward && 'font-bold text-blue-600'
											)}
										>
											Reward
										</div>
										<div className={cn('h-[3px] w-[5px] rounded-[100px] bg-[#3369B2]', !reward && 'invisible')} />
									</div>
									<div
										className="flex flex-col items-center justify-center basis-1/5 gap-1"
										onClick={() => navigate('/history')}
									>
										<img
											className="h-[22px] w-[22px]"
											src={
												history
													? require('@/assets/icons/history-active.png')
													: require('@/assets/icons/history-inactive.png')
											}
											alt="Riwayat"
										/>
										<div
											className={cn(
												'font-medium text-gray-500 text-[12px] leading-none',
												history && 'font-bold text-blue-600'
											)}
										>
											Riwayat
										</div>
										<div className={cn('h-[3px] w-[5px] rounded-[100px] bg-[#3369B2]', !history && 'invisible')} />
									</div>
									<div
										className="flex flex-col items-center justify-center basis-1/5 gap-1"
										onClick={() => navigate('/profile')}
									>
										<img
											className="h-[22px] w-[22px]"
											src={
												profile
													? require('@/assets/icons/profile-active.png')
													: require('@/assets/icons/profile-inactive.png')
											}
											alt="Profile"
										/>
										<div
											className={cn(
												'font-medium text-gray-500 text-[12px] leading-none',
												profile && 'font-bold text-blue-600'
											)}
										>
											Profile
										</div>
										<div className={cn('h-[3px] w-[5px] rounded-[100px] bg-[#3369B2]', !profile && 'invisible')} />
									</div>
								</div>
						</div>
					</div>
				</div>,
				container
			)}
		</div>
	)
}
